import cn from 'classnames';
import {extendTailwindMerge} from 'tailwind-merge';

const twMerge = extendTailwindMerge({
    extend: {
        classGroups: {
            padding: [
                // This tells twMerge that `pt-0`, `pt-1`, ... and `pt-0-hw-offset`, `pt-1-hw-offset` are in same group
                {pt: ['hw-offset']},
            ],
        },
        conflictingClassGroups: {
            pt: ['pt'], // ensure it knows pt conflicts with itself (default, but we reinforce)
        },
        // Add custom utility matching for the suffix
        theme: {
            // Tell twMerge to treat keys like `0-hw-offset` as valid spacing keys
            spacing: (value) => {
                return /^[\d.]+(?:-hw-offset)?$/.test(value); // matches "0", "1", "2.5", "0-hw-offset"
            },
        },
    },
});

export const twx = (...props) => twMerge(cn(props));
